module.exports = __webpack_public_path__ + "img/archived.668ca550.svg";